import request from './axios'

// 邮箱注册
export function mobileEmail(data) {
  return request({
    url: '/app-api/mobile-email',
    method: 'post',
    data
  })
}

// 手机号注册
export function mobileRegister(data) {
  return request({
    url: '/app-api/mobile-register',
    method: 'post',
    data
  })
}

// 手机号|邮箱密码登录
export function login(data) {
  return request({
    url: '/app-api/login',
    method: 'post',
    data
  })
}

// 手机号|邮箱验证码登录
export function loginByPhone(data) {
  return request({
    url: '/app-api/login-by-phone',
    method: 'post',
    data
  })
}

// 获取手机验证码  登录
export function getPhoneCodeDl(data) {
  return request({
    url: '/app-api/get-phone-valid-code',
    method: 'post',
    data
  })
}

// 获取手机验证码  注册
export function getPhoneCodeZc(data) {
  return request({
    url: '/app-api/get-phone-zc-valid-code',
    method: 'post',
    data
  })
}

// 获取手机验证码  忘记密码
export function getPhoneCodeWj(data) {
  return request({
    url: '/app-api/get-phone-wj-valid-code',
    method: 'post',
    data
  })
}

// 获取邮箱验证码  登录
export function getEmailCodeDl(data) {
  return request({
    url: '/app-api/get-email-valid-code',
    method: 'post',
    data
  })
}

// 获取邮箱验证码  注册
export function getEmailCodeZc(data) {
  return request({
    url: '/app-api/get-email-zc-valid-code',
    method: 'post',
    data
  })
}

// 获取邮箱验证码  忘记密码
export function getEmailCodeWj(data) {
  return request({
    url: '/app-api/get-email-wj-valid-code',
    method: 'post',
    data
  })
}

// 重置密码
export function resetPassword(data) {
  return request({
    url: '/app-api/reset-password',
    method: 'post',
    data
  })
}



// 参数配置详情   
export function configDetail(query) {
  return request({
    url: '/app-api/system/config/detail',
    method: 'get',
    params: query
  })
}

// 新闻分页
export function newsPage(query) {
  return request({
    url: '/app-api/global/global-news/page',
    method: 'get',
    params: query
  })
}

// 新闻详情
export function newsDetail(query) {
  return request({
    url: '/app-api/global/global-news/detail',
    method: 'get',
    params: query
  })
}

// 关于、方法、数据的数据     类型 0-关于 1-方法 2-数据
export function generalDetail(query) {
  return request({
    url: '/app-api/global/global-general/detail',
    method: 'get',
    params: query
  })
}

// 团队分页
export function teamPage(query) {
  return request({
    url: '/app-api/global/global-team/page',
    method: 'get',
    params: query
  })
}

// 团队详情
export function teamDetail(query) {
  return request({
    url: '/app-api/global/global-team/detail',
    method: 'get',
    params: query
  })
}

// 联系方式管理列表
export function contactList(query) {
  return request({
    url: '/app-api/global/global-contact/list',
    method: 'get',
    params: query
  })
}

// 联系我们详情
export function contactUsDetail(query) {
  return request({
    url: '/app-api/global/global-contact-us/detail',
    method: 'get',
    params: query
  })
}



// 企业列表
export function enterpriseListAll(query) {
  return request({
    url: '/app-api/global/global-data-info/company/name/list/all',
    method: 'get',
    params: query
  })
}

// 行业列表
export function tradeListAll(query) {
  return request({
    url: '/app-api/global/global-data-info/trade/list/all',
    method: 'get',
    params: query
  })
}

// 年份列表
export function yearListAll(query) {
  return request({
    url: '/app-api/global/global-data-info/year/list/all',
    method: 'get',
    params: query
  })
}

// 地图数据统计
export function dataInfoDtList(query) {
  return request({
    url: '/app-api/global/global-data-info/dt/list',
    method: 'get',
    params: query
  })
}

// 总碳排放量统计
export function carbonEmissionList(query) {
  return request({
    url: '/app-api/global/global-data-info/carbonEmission/list',
    method: 'get',
    params: query
  })
}

// 总碳每个企业的排放量
export function companyNameList(query) {
  return request({
    url: '/app-api/global/global-data-info/company/name/list',
    method: 'get',
    params: query
  })
}

// 总碳每个行业的排放量
export function tradeList(query) {
  return request({
    url: '/app-api/global/global-data-info/trade/list',
    method: 'get',
    params: query
  })
}

// 导出数据统计列表
export function exportData(data) {
  return request({
    url: '/app-api/global/global-data-info/export',
    method: 'post',
    data,
    responseType: 'blob'
  })
}

// 导出数据统计列表  企业
export function exportQyData(data) {
  return request({
    url: '/app-api/global/global-data-info/qy/export',
    method: 'post',
    data,
    responseType: 'blob'
  })
}

// 导出数据统计列表  行业
export function exportHyData(data) {
  return request({
    url: '/app-api/global/global-data-info/hy/export',
    method: 'post',
    data,
    responseType: 'blob'
  })
}



// 获得当前用户信息
export function getUserInfo(query) {
  return request({
    url: '/app-api/biz/user/getByToken',
    method: 'get',
    params: query
  })
}

// 更新用户信息
export function userUpdate(data) {
  return request({
    url: '/app-api/biz/user/update',
    method: 'post',
    data
  })
}

// 提交意见反馈
export function feedbackAdd(data) {
  return request({
    url: '/app-api/biz/app-feedback/create',
    method: 'post',
    data
  })
}

// 获得登录人意见反馈分页
export function feedbackPage(query) {
  return request({
    url: '/app-api/biz/app-feedback/page/curr-user',
    method: 'get',
    params: query
  })
}

// 修改用户密码
export function updatePassword(data) {
  return request({
    url: '/app-api/biz/user/update-password',
    method: 'post',
    data
  })
}

// 积分充值配置列表
export function integralList(query) {
  return request({
    url: '/app-api/global/global-recharge-integral/list',
    method: 'get',
    params: query
  })
}

// 积分充值
export function orderAdd(data) {
  return request({
    url: '/app-api/global/global-recharge-order/add',
    method: 'post',
    data
  })
}

// 订阅配置列表
export function subscriptionList(query) {
  return request({
    url: '/app-api/global/global-recharge-subscription/list',
    method: 'get',
    params: query
  })
}

// 订阅
export function orderEdit(data) {
  return request({
    url: '/app-api/global/global-recharge-order/edit',
    method: 'post',
    data
  })
}

// 数据下载列表
export function amountList(query) {
  return request({
    url: '/app-api/global/global-data-info-amount/list',
    method: 'get',
    params: query
  })
}

// 数据单个下载
export function amountAdd(data) {
  return request({
    url: '/app-api/global/global-data-info-amount/add',
    method: 'post',
    data,
    responseType: 'blob'
  })
}

// 数据全部下载
export function amountEdit(data) {
  return request({
    url: '/app-api/global/global-data-info-amount/edit',
    method: 'post',
    data,
    responseType: 'blob'
  })
}

// 全部下载需要多少积分
export function amountInfo(query) {
  return request({
    url: '/app-api/global/global-data-info-amount/info',
    method: 'get',
    params: query
  })
}




// 修改绑定手机号-旧手机号发送验证码
export function phoneOldCode(data) {
  return request({
    url: '/app-api/biz/user/update-phone-old-code',
    method: 'post',
    data
  })
}

// 修改绑定手机号-新手机号发送验证码
export function phoneNewCode(data) {
  return request({
    url: '/app-api/biz/user/update-phone-new-code',
    method: 'post',
    data
  })
}

// 修改绑定手机号
export function phoneUpdate(data) {
  return request({
    url: '/app-api/biz/user/update-phone',
    method: 'post',
    data
  })
}

// 修改绑定邮箱-旧邮箱发送验证码
export function emailOldCode(data) {
  return request({
    url: '/app-api/biz/user/update-email-old-code',
    method: 'post',
    data
  })
}

// 修改绑定邮箱-新邮箱发送验证码
export function emailNewCode(data) {
  return request({
    url: '/app-api/biz/user/update-email-new-code',
    method: 'post',
    data
  })
}

// 修改绑定邮箱
export function emailUpdate(data) {
  return request({
    url: '/app-api/biz/user/update-email',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/utils/api.js